import Depositereportparameters from "./Depositereportparameters";
import Loanreportparameters from "./Loanreportparameters";
import Invenstmentreportparameters from "./Invenstmentreportparameters";
import Otherparameterreports from "./Otherparameterreports";


export default {
    ...Depositereportparameters,
    ...Loanreportparameters,
    ...Invenstmentreportparameters,
    ...Otherparameterreports
}